import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IDeleteFn, ITrainingPerson, IGetPutRequest } from '../../interfaces'

const getRevertSeparationTrainingPersonMutationRequest: IGetPutRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/People/`,
})

const useRevertSeparationTrainingPersonMutation: IUseUpdateMutation<ITrainingPerson, number> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getRevertSeparationTrainingPersonMutationRequest(params), [params])

  const revertSeparationTrainingPerson: IDeleteFn<ITrainingPerson> = useCallback(
    async id => axios({ ...request, url: request.url + id + '/revert-separation' }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingPerson, Error, any>({
    mutationFn: revertSeparationTrainingPerson,
    ...options,
  })

  return response
}

export default useRevertSeparationTrainingPersonMutation
